module.exports = __webpack_public_path__ + "img/sg.a1222d2d.svg";